import React from "react";

export const LeftArrowIcon = ({ width, height, extraClasses }) => {
  return (
    <span role="img" className={extraClasses}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || "100%"}
        height={height || "100%"}
        viewBox="0 0 5 10"
        fill="none"
      >
        <g clipPath="url(#clip0_619_4608)">
          <mask id="path-1-inside-1_619_4608" fill="white">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.38477 10.0996L0.384766 5.10048L5.38477 0.0996094"
            />
          </mask>
          <path
            d="M6.09181 9.39244C6.48237 9.78293 6.48242 10.4161 6.09193 10.8067C5.70144 11.1972 5.06828 11.1973 4.67772 10.8068L6.09181 9.39244ZM0.384766 5.10048L-0.32228 5.80764L-1.02945 5.1006L-0.322402 4.39343L0.384766 5.10048ZM4.6776 -0.607436C5.06809 -0.997994 5.70125 -0.998049 6.09181 -0.607559C6.48237 -0.217069 6.48242 0.416097 6.09193 0.806655L4.6776 -0.607436ZM4.67772 10.8068L-0.32228 5.80764L1.09181 4.39331L6.09181 9.39244L4.67772 10.8068ZM-0.322402 4.39343L4.6776 -0.607436L6.09193 0.806655L1.09193 5.80752L-0.322402 4.39343Z"
            fill="#AAAAAA"
            mask="url(#path-1-inside-1_619_4608)"
          />
        </g>
        <defs>
          <clipPath id="clip0_619_4608">
            <rect width="5" height="10" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};
